import {
    ConditionDefinitionDto,
    ConditionDefinitionProduct,
    ConditionDefinitionTrigger,
} from '@/components/shared/api/endpoints/conditionDefinitions';
import { BaseTemplate } from '@/components/shared/components/TemplateManager/TemplateManager.types';
import {
    getReviewTeams,
    ReviewTeam,
} from '@/components/pages/Applicant/components/ApplicantConditions/conditionTemplates';

export interface ConditionDefinitionTemplate extends BaseTemplate {
    code: string | null;
    isPerOwner: boolean;
    hasAutoComment: boolean;
    defaultProducts: ConditionDefinitionProduct[];
    referenceProducts: ConditionDefinitionProduct[];
    reviewTeams: ReviewTeam[];
    triggers: ConditionDefinitionTrigger[];
    rowVersion: number;
}

export const toConditionDefinitionTemplate = (
    dto: ConditionDefinitionDto,
): ConditionDefinitionTemplate => ({
    id: dto.id,
    label: dto.label,
    body: dto.descriptionTemplate,
    isActive: dto.isActive,
    code: dto.code,
    isPerOwner: dto.isPerOwner,
    hasAutoComment: dto.hasAutoComment,
    defaultProducts: dto.defaultProducts,
    referenceProducts: dto.referenceProducts,
    reviewTeams: getReviewTeams(dto.reviewTeams),
    triggers: dto.triggers ?? [],
    rowVersion: dto.rowVersion,
});
